import { Anchor, Text, UnstyledButton, type MantineFontSize } from "@mantine/core";
import classes from "../list.module.css";

type Props = {
  value?: string | null;
  onClick?: () => void;
  /** Default gray.9 (canvas: document numbers are neutral, not brand). */
  color?: string;
  fw?: number;
  /** When false, omit the leading «#». Default true. */
  showHash?: boolean;
  /** Font size; default «sm» (14). Closed list uses 13. */
  fz?: MantineFontSize | number;
  className?: string;
  /** Underline on hover. Default true. */
  underlineOnHover?: boolean;
};

function DocNoContent({ code, showHash }: { code: string; showHash: boolean }) {
  const trimmed = code.replace(/^#+/, "").trim();
  if (!trimmed) {
    return null;
  }
  return (
    <>
      {showHash ? (
        <Text component="span" size="sm" className={classes.docNoHash}>
          #
        </Text>
      ) : null}
      {trimmed}
    </>
  );
}

export function DocNoCell({
  value,
  onClick,
  color = "gray.9",
  fw,
  showHash = true,
  fz = "sm",
  className: classNameProp,
  underlineOnHover = true,
}: Props) {
  const raw = typeof value === "string" ? value.trim() : "";
  if (!raw) {
    return (
      <Text size="sm" c="dimmed">
        -
      </Text>
    );
  }

  const content = <DocNoContent code={raw} showHash={showHash} />;
  const className = [
    classes.docNo,
    fw === 500 ? classes.docNoMedium : null,
    underlineOnHover ? classes.docNoHoverUnderline : null,
    classNameProp,
  ]
    .filter(Boolean)
    .join(" ");

  if (onClick) {
    return (
      <UnstyledButton className={className} c={color} fz={fz} onClick={onClick} type="button">
        {content}
      </UnstyledButton>
    );
  }

  return (
    <Anchor component="span" className={className} c={color} fz={fz} underline="never">
      {content}
    </Anchor>
  );
}
